import '@angular/compiler';
import 'zone.js';
import '@angular/localize/init';
require('../manifest.webapp');
